import type { JSX } from 'react';

import { ChevronLeft, ChevronRight } from 'lucide-react';

import { Button } from '@/components/ui/button';

interface ActivityPaginationProps {
  offset: number;
  pageSize: number;
  total: number;
  currentPage: number;
  totalPages: number;
  isFetching: boolean;
  onOffsetChange: (offset: number) => void;
}

const ActivityPagination = ({
  offset,
  pageSize,
  total,
  currentPage,
  totalPages,
  isFetching,
  onOffsetChange,
}: ActivityPaginationProps): JSX.Element | null => {
  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="flex items-center justify-between pt-2">
      <p className="m-0 text-xs text-text-muted font-body">
        Mostrando {offset + 1}–{Math.min(offset + pageSize, total)} de {total}
      </p>
      <div className="flex items-center gap-1">
        <Button
          variant="outline"
          size="icon-sm"
          onClick={() => onOffsetChange(Math.max(0, offset - pageSize))}
          disabled={offset === 0 || isFetching}
          aria-label="Página anterior"
        >
          <ChevronLeft className="size-4" aria-hidden />
        </Button>
        <Button
          variant="outline"
          size="icon-sm"
          onClick={() => onOffsetChange(offset + pageSize)}
          disabled={currentPage >= totalPages || isFetching}
          aria-label="Página siguiente"
        >
          <ChevronRight className="size-4" aria-hidden />
        </Button>
      </div>
    </div>
  );
};

export default ActivityPagination;
